<template>
  <PageSecondary>
    <template #title>Level Up Public</template>
    <h1 style="font-size: xx-large; font-weight: 900;">Get an Invite</h1>

    <div style="margin: 16px 0;">
      Я провожу тренинги в полузакрытом режиме и слежу за тем, чтобы на них приходили те, кому они действительно принесут пользу.
    </div>

    <img src="@/assets/kid8.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">


    <div style="font-style: italic; margin-top: 16px; color: red;">
      Условия
    </div>
    <div style="font-style: italic; margin-bottom: 256px; margin-top: 16px;">
      Напиши мне в телеграм, мы познакомимся и обсудим твои ожидания от тренингов. Я добавлю тебя в закрытый канал с анонсами.<br><br>
      Обычно встреча на 8 участников. Длительность 3-4 часа. Стоимость от бесплатно до 1500₽ за участие.<br><br>
      * Поужинать за час до встречи. Чтоб 3 часа не сидели голодные и не пришли с набитым брюхом, потому что мы потрошим ваш внутренний мир (с)
    </div>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: 'LevelUpPublic_2021_08_12',
  components: {PageSecondary},
  props: {
    secret: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
